export default __webpack_public_path__ + "static/media/brackets_logo.9701eaf9.svg";